// src/components/AnimatedText.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../App.css';

function AnimatedText({ text, className = '' }) {
  const { t } = useTranslation(); // 🔥 Move translation here
  const translated = t(text);     // Translate the key passed

  return (
    <h1 className={`animated-text ${className}`} aria-label={translated}>
      {translated.split('').map((char, index) => (
        <span
          key={index}
          aria-hidden="true"
          className={char === ' ' ? 'animated-space' : undefined}
        >
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </h1>
  );
}

export default AnimatedText;
